import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen bg-[#0A0E27] text-white font-sans selection:bg-[#FF5722] selection:text-white" data-id="element-65" data-mp="zx4cau4aqsc3">
      <Header data-id="element-66" data-mp="uy1jc81lcckh" />
      {children}
      <Footer data-id="element-67" data-mp="uyufyg6u5low" />
    </div>;
}